
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"32","height":"32","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"stroke":"#131313","stroke-width":"2","cx":"16","cy":"16","r":"15"}}),_c('path',{attrs:{"fill":"#131313","d":"M15 8h2v16h-2z"}}),_c('path',{attrs:{"fill":"#131313","d":"M8 15h16v2H8z"}})])])
      }
    
      }
    